import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import Endpoint from './endpoints';

class ApisConfigure {
  ApiAuth!: AxiosInstance;
  ApiIAM!: AxiosInstance;

  /**
   * Intercepta todas as requisições
   * @param config
   */
  requestInterceptors = (config: any) => {
    return config;
  };

  axiosStart = (config: AxiosRequestConfig): AxiosInstance => {
    // Default Headers
    //axios.defaults.headers.common['Access-Control-Allow-Credentials'] = true;
    //axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

    const api = axios.create(config);
    api.interceptors.request.use(this.requestInterceptors);
    return api;
  };

  axiosInstances = (): Array<AxiosInstance> => {
    return [this.ApiAuth, this.ApiIAM];
  };

  initApis = () => {
    this.ApiAuth = this.axiosStart({
      baseURL: Endpoint.apiAuth!,
      timeout: Endpoint.timeout,
      withCredentials: true,
    });

    this.ApiIAM = this.axiosStart({
      baseURL: Endpoint.apiIAM!,
      timeout: Endpoint.timeout,
      withCredentials: true,
    });
  };

  configureConsumer = (baseUrl?: string, basePort?: string): void => {
    Endpoint.configureEndpoint(baseUrl, basePort);
    this.initApis();
  };
}

const Apis = new ApisConfigure();
export default Apis;
